import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Customers API
export const customersAPI = {
  getAll: () => axios.get(`${API_URL}/customers`),
  getOne: (id) => axios.get(`${API_URL}/customers/${id}`),
  create: (data) => axios.post(`${API_URL}/customers`, data),
  update: (id, data) => axios.put(`${API_URL}/customers/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/customers/${id}`),
};

// Machines API
export const machinesAPI = {
  getAll: () => axios.get(`${API_URL}/machines`),
  getOne: (id) => axios.get(`${API_URL}/machines/${id}`),
  create: (data) => axios.post(`${API_URL}/machines`, data),
  update: (id, data) => axios.put(`${API_URL}/machines/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/machines/${id}`),
};

// Readings API
export const readingsAPI = {
  getAll: () => axios.get(`${API_URL}/readings`),
  getByMachine: (machineId) => axios.get(`${API_URL}/readings/machine/${machineId}`),
  getByPeriod: (year, month) => axios.get(`${API_URL}/readings/year/${year}/month/${month}`),
  create: (data) => axios.post(`${API_URL}/readings`, data),
  update: (id, data) => axios.put(`${API_URL}/readings/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/readings/${id}`),
};

// Catalog API
export const catalogAPI = {
  getAll: () => axios.get(`${API_URL}/catalog`),
  getBrands: () => axios.get(`${API_URL}/catalog/brands`),
  getOne: (id) => axios.get(`${API_URL}/catalog/${id}`),
  create: (data) => axios.post(`${API_URL}/catalog`, data),
  update: (id, data) => axios.put(`${API_URL}/catalog/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/catalog/${id}`),
};

// Consumables API
export const consumablesAPI = {
  getAll: () => axios.get(`${API_URL}/consumables`),
  getOne: (id) => axios.get(`${API_URL}/consumables/${id}`),
  getForMachine: (machineId) => axios.get(`${API_URL}/consumables/for-machine/${machineId}`),
  create: (data) => axios.post(`${API_URL}/consumables`, data),
  update: (id, data) => axios.put(`${API_URL}/consumables/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/consumables/${id}`),
  linkToModel: (consumableId, catalogId) => 
    axios.post(`${API_URL}/consumables/${consumableId}/models/${catalogId}`),
  unlinkFromModel: (consumableId, catalogId) => 
    axios.delete(`${API_URL}/consumables/${consumableId}/models/${catalogId}`),
};

// Service API
export const serviceAPI = {
  getAll: () => axios.get(`${API_URL}/service`),
  getByMachine: (machineId) => axios.get(`${API_URL}/service/machine/${machineId}`),
  create: (data) => axios.post(`${API_URL}/service`, data),
  update: (id, data) => axios.put(`${API_URL}/service/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/service/${id}`),
};

// Dispatches API
export const dispatchesAPI = {
  getAll: () => axios.get(`${API_URL}/dispatches`),
  getByMachine: (machineId) => axios.get(`${API_URL}/dispatches/machine/${machineId}`),
  create: (data) => axios.post(`${API_URL}/dispatches`, data),
  update: (id, data) => axios.put(`${API_URL}/dispatches/${id}`, data),
  delete: (id) => axios.delete(`${API_URL}/dispatches/${id}`),
};

// Dashboard API
export const dashboardAPI = {
  getStats: (year) => axios.get(`${API_URL}/dashboard/stats/${year}`),
};
